var _rect, _line, _line2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4.841,
    width: 20,
    height: 14.318,
    rx: 3.771,
    ry: 3.771
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.914,
    y1: 8.57,
    x2: 18.449,
    y2: 8.57
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.914,
    y1: 11.64,
    x2: 14.949,
    y2: 11.64
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.592,
    cy: 15.049,
    r: 0.339
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.192,
    cy: 15.049,
    r: 0.339
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.793,
    cy: 15.049,
    r: 0.339
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCard);
export default __webpack_public_path__ + "static/media/view-card.2e5071c47e101844e85f4b617fb9b278.svg";
export { ForwardRef as ReactComponent };